import { QueryStringInput } from '@hello-aria/query-string'
import { isNil } from 'lodash'
import { PaymentReconciliationGateway } from '../../../shared/models/paymentReconciliationModel'
import { RequestResponse, requestService } from '../../../shared/services/requestServices'
import { batchFetch, resolveApiUrl } from '../../../shared/utils/requestsUtils'
import { handleHttpError } from '@/shared/utils/queryUtils'

interface ListPaymentReconciliationsParams {
    companyId: string
    query?: QueryStringInput
    signal?: AbortSignal
}

export const listPaymentReconciliationsService = batchFetch(
    async (
        params: ListPaymentReconciliationsParams
    ): Promise<RequestResponse<PaymentReconciliationGateway[]> | undefined> => {
        try {
            const url = resolveApiUrl('paymentReconciliations.getAll', {
                variables: { companyId: params.companyId },
                query: {
                    ...params.query,
                    sorts: params.query?.sorts ?? [
                        {
                            path: 'createdAt',
                            direction: 'desc'
                        }
                    ]
                }
            })

            const response = await requestService<PaymentReconciliationGateway[]>(
                url,
                params.signal
                    ? {
                          signal: params.signal
                      }
                    : undefined
            )

            return response
        } catch (error) {
            handleHttpError('listPaymentReconciliationsService', error)
        }
    }
)

export const getPaymentReconciliationByIdService = async (
    companyId: string,
    paymentReconciliationId: string | undefined
): Promise<RequestResponse<PaymentReconciliationGateway> | undefined> => {
    if (isNil(paymentReconciliationId)) return

    try {
        const url = resolveApiUrl('paymentReconciliations.get', {
            variables: { paymentReconciliationId, companyId }
        })
        const response = await requestService<PaymentReconciliationGateway>(url)

        return response
    } catch (error) {
        handleHttpError('getPaymentReconciliationByIdService', error)
    }
}
